import React from 'react';

import SkeletonBase from './SkeletonBase';
import Classes from './Skeleton.module.scss';

type TProps = {
  withAnimation?: boolean;
  size: string;
};

const CircleSkeleton = ({ withAnimation, size }: TProps) => (
  <SkeletonBase className={Classes.CircleSkeleton} width={size} height={size} withAnimation={withAnimation} />
);

export default CircleSkeleton;
